/* eslint-env jest */
import visiblePoses from './visiblePoses';

const pose = (id) => ({ id, url: `x-${id}.png` });
const ids = (list) => list.map((p) => p.id);

// Poses arrive as an array; favoriteIds are strings from the URL.
const poses = [pose('1'), pose('2'), pose('3'), pose('4')];

describe('visiblePoses', () => {
  describe('the favorites PICKER (restrictToFavorites = true)', () => {
    // The bug: the customer picked a subset of favorites, but the builder showed all.
    it('shows ONLY the favorited poses', () => {
      const result = visiblePoses(poses, ['2', '4'], {}, true);
      expect(ids(result).sort()).toEqual(['2', '4']);
    });

    // Buy All / digital-images-only delivers every photo — favorites must NOT narrow it.
    it('keeps ALL poses for a buy-all (digitalImagesOnly) option', () => {
      const result = visiblePoses(poses, ['2'], { digitalImagesOnly: true }, true);
      expect(ids(result).sort()).toEqual(['1', '2', '3', '4']);
    });

    // Stale / non-matching ids must not blank the builder.
    it('falls back to all poses when favorite ids match nothing', () => {
      expect(ids(visiblePoses(poses, ['999'], {}, true)).sort()).toEqual(['1', '2', '3', '4']);
    });

    it('falls back to all poses when no favorites are given', () => {
      expect(ids(visiblePoses(poses, [], {}, true)).sort()).toEqual(['1', '2', '3', '4']);
    });
  });

  // The core of the review BLOCKER: favoriteIds is overloaded. Callers that pass it only
  // to highlight/sort (senior yearbook pose, MultiPoseEdit's heart badge) must NOT filter
  // — they leave restrictToFavorites off (the default) and keep the whole session.
  describe('highlight/sort-only callers (restrictToFavorites defaults false)', () => {
    it('SENIOR: passing the single yearbook pose keeps ALL poses, that one first', () => {
      // SeniorMultiPose passes favoriteIds={[yearbookPose.id]} for sort, not filter.
      const result = visiblePoses(poses, ['3'], {});
      expect(ids(result).sort()).toEqual(['1', '2', '3', '4']); // full session intact
      expect(result[0].id).toBe('3'); // yearbook pose sorted first
    });

    it('EDIT: passing the poses already in the order keeps ALL poses (swaps allowed)', () => {
      // MultiPoseEdit passes favoriteIds={order sheets} for the heart badge only.
      const result = visiblePoses(poses, ['1', '2'], {});
      expect(ids(result).sort()).toEqual(['1', '2', '3', '4']);
    });

    it('an explicit false behaves the same as the default', () => {
      expect(ids(visiblePoses(poses, ['2'], {}, false)).sort()).toEqual(['1', '2', '3', '4']);
    });
  });

  it('does not mutate the caller’s poses array', () => {
    const input = [pose('3'), pose('1'), pose('2')];
    const snapshot = ids(input);
    visiblePoses(input, ['2'], {}, true);
    expect(ids(input)).toEqual(snapshot);
  });

  it('handles empty / missing poses without throwing', () => {
    expect(visiblePoses([], ['1'], {}, true)).toEqual([]);
    expect(visiblePoses(undefined, ['1'], {}, true)).toEqual([]);
  });
});
